import { create } from 'zustand';

export const useTailorabilityStore = create((set) => ({
    activeTab: 'custom-fields',
    customFields: [],
    formLayouts: [],
    customPermissions: [],
    branding: null,
    featureFlags: [],
    loading: false,
    error: null,
    setActiveTab: (activeTab) => set({ activeTab }),
    setCustomFields: (customFields) => set({ customFields }),
    setFormLayouts: (formLayouts) => set({ formLayouts }),
    setCustomPermissions: (customPermissions) => set({ customPermissions }),
    setBranding: (branding) => set({ branding }),
    setFeatureFlags: (featureFlags) => set({ featureFlags }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
}));

export default useTailorabilityStore;
